import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import { useMutation, useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";

const getAllUserGroup = async ({ companyCode }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetUserGroups}?companyCode=${companyCode}`
  );
  return data;
};

const getUserGroup = async ({ userID, companyCode }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetUserGroup}?UserID=${userID}&companyCode=${companyCode}`
  );
  return data;
};

const insertUserGroup = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.InsertUserGroup,
    input
  );
  return data;
};

const updateUserGroup = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.UpdateUserGroup,
    input
  );
  return data;
};

const deleteUserGroup = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.DeleteUserGroup}?companyCode=${companyCode}&UserGroupCode=${code}`
  );
  return data;
};

export const useGetAllUserGroupQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetUserGroups],
    queryFn: () => getAllUserGroup(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetUserGroupByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetUserGroup],
    queryFn: () => getUserGroup(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertUserGroupMutation = () => {
  return useMutation({
    mutationFn: insertUserGroup,
  });
};

export const useUpdateUserGroupMutation = () => {
  return useMutation({
    mutationFn: updateUserGroup,
  });
};

export const useDeleteUserGroupMutation = () => {
  return useMutation({
    mutationFn: deleteUserGroup,
  });
};
